<template lang="pug">
.terms-conditions-website
  .content
    .homelink(@click="$router.push('/')") < Retour au site
    VueMarkdown(:linkify="false") {{ content }}
  Footer.footer(:white="true")
</template>

<script>
import VueMarkdown from 'vue-markdown'
import content from '@/assets/terms-conditions-website.md'
import Footer from './../home/Footer'

export default {
  name: 'TermsConditionsWebsite',
  components: {
    VueMarkdown,
    Footer
  },
  data: () => ({
    content
  })
}
</script>

<style lang="scss" scoped>
@use '@/styles/colors';

.terms-conditions-website {
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  color: white;
  background-image: linear-gradient(
    100deg,
    colors.$intense-purple,
    colors.$light-purple-gradient
  );

  .content {
    max-width: 80%;
    padding-top: 30px;
    margin: auto;
  }

  .homelink:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>

<style lang="scss">
@use '@/styles/text';

h1 {
  @include text.title;
  text-align: left;
  font-size: 25px;
}

h2 {
  @include text.subtitle;
  text-align: left;
  font-size: 22px;
}

h3 {
  @include text.subtitle;
  text-align: left;
  font-size: 18px;
}
</style>
